import { FC, useEffect, useState } from 'react';
import './ModalArticlesSubsectionsInsert.scss';
import ModalDefault from '../../../../components/ModalDefault/ModalDefault';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from '../../../../providers/AuthProvider';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Col, FormGroup, Row } from 'react-bootstrap';
import ErrorMessage from '../../../../components/ErrorMessage/ErrorMessage';
import { schema } from './Validate';
import ReactSelect from "react-select";
import { Controller } from 'react-hook-form';
import { useSubsections } from '../../../../providers/Articles/Subsections/SubsectionsProvider';
import { SubsectionModel } from '../../../../models/Articles/Subsections/SubsectionModel';
import { useSections } from '../../../../providers/Articles/Sections/SectionsProvider';
import { customStyles } from '../../../../models/SelectCustomStyles';

interface ModalArticlesSubsectionsInsertProps {
  show: boolean;
  onClose: () => void;
}

type FormValues = {
  id?: number;
  name?: string;
  description?: string;
  section_id?: number;
}

const ModalArticlesSubsectionsInsert: FC<ModalArticlesSubsectionsInsertProps> = ({ show, onClose }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [selectedSection, setSelectedSection] = useState<any | null>(null);

  const { sectionsOptions } = useSections();
  const { subsection, setSubsection, setError, handleList, handleFetch } = useSubsections();
  const { onInvalid } = useAuth();

  const { handleSubmit, register, setValue, reset, control, formState: { errors } } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const handleClose = () => {
    setError('');
    setSubsection({} as SubsectionModel);
    setSelectedSection(null);
    onClose();
  }

  const onSubmit = async (data: any) => {
    setIsLoadingSubmit(true);
    setError('');

    const ret = await handleFetch(data as SubsectionModel);

    if (ret) {
      toast.success('Subseção salva com sucesso!');
      handleList();
      onClose();
    }

    setIsLoadingSubmit(false);
  }

  useEffect(() => {
    if (show) {
      if (!!subsection?.id) {
        reset(subsection as FormValues);
      } else {
        reset(new SubsectionModel());
        setSubsection({} as SubsectionModel);
        setSelectedSection(null);
      }
    }
  }, [show]);

  useEffect(() => {
    setValue('section_id', selectedSection?.value || '');
  }, [selectedSection]);

  useEffect(() => {
    if (subsection?.id && sectionsOptions?.length > 0) {
      setSelectedSection(sectionsOptions.filter((item: any) => item.value === subsection.section?.id)?.shift());
    }
  }, [sectionsOptions, subsection]);

  return (
    <ModalDefault
      title={!!subsection?.id ? 'Editar Subseção de Artigos' : 'Adicionar Subseção de Artigos'}
      show={show}
      onClose={handleClose}
      sizeModal={'lg'}
      showFooter={true}
      buttonText={isLoadingSubmit ? 'Salvando...' : 'Salvar'}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={isLoadingSubmit}
      handleSubmit={handleSubmit(onSubmit)}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div className="ModalArticlesSubsectionsInsert" data-testid="ModalArticlesSubsectionsInsert">
        <Row>
          <Col md={8}>
            <FormGroup className="form-group">
              <label htmlFor="name">NOME *</label>
              <input
                className={`form-control ${onInvalid(errors?.name)}`}
                type='text'
                {...register('name')}
                onChange={(e: any) => setSubsection({ ...subsection, name: e?.target?.value })}
              />
              <ErrorMessage name={'Nome'} type={errors?.name?.type?.toString()} min={3} max={100} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="form-group">
              <label htmlFor="section_id">SEÇÃO *</label>
              {control && (
                <Controller
                  name="section_id"
                  control={control}
                  render={({ field: { onChange, value, name, ref } }) => (
                    <ReactSelect
                      isSearchable
                      options={sectionsOptions ?? []}
                      value={selectedSection}
                      placeholder="Selecione"
                      className={`form-control p-0 ${onInvalid(errors?.section_id)}`}
                      noOptionsMessage={() => "Não há registros"}
                      styles={customStyles}
                      onChange={(e) => {
                        setValue("section_id", e?.value);
                        setSelectedSection(e)
                      }}
                    />
                  )}
                />
              )}
              <ErrorMessage name={"Seção"} type={errors?.section_id?.type?.toString()} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup className="form-group">
              <label htmlFor="description">DESCRIÇÃO</label>
              <textarea
                rows={5}
                id="description"
                className={`form-control ${onInvalid(errors?.description)}`}
                {...register("description")}
              />
              <ErrorMessage
                name={"Descrição"}
                type={errors?.description?.type?.toString()}
                min={3}
                max={1000}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </ModalDefault>
  );
}

export default ModalArticlesSubsectionsInsert;
